/****************************************************
 * Module Name:  stonestatusProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class StonestatusProxy {
  static GetAllStonestatus = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonestatus",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStonestatusMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonestatus/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleStonestatus = (StonestatusId, callback) => {
    let params = {
      id: StonestatusId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/stonestatus",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckStonestatusAvailable = (stonestatus, callback) => {
    let params = {
      stonestatus: stonestatus,
    };

    restAPICall(
      Constants.MANAGER_URL + "/stonestatus/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddStonestatus = (stonestatus, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonestatus",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(stonestatus),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateStonestatus = (stonestatus, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonestatus",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(stonestatus),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
